import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class LoadingFileService {
  private initLoading = {
    isCSVLoading: false,
    isPDFLoading: false,
  }

  private isFileLoading = new BehaviorSubject<{ [param: string]: boolean }>(this.initLoading)
  readonly isFileLoading$ = this.isFileLoading.asObservable()

  clearFileLoading(): void {
    this.isFileLoading.next({
      isCSVLoading: false,
      isPDFLoading: false,
    })
  }

  setPDFLoading(): void {
    this.isFileLoading.next({
      isCSVLoading: false,
      isPDFLoading: true,
    })
  }

  setCSVLoading(): void {
    this.isFileLoading.next({
      isCSVLoading: true,
      isPDFLoading: false,
    })
  }
}
